import { skipToken, useQuery } from "@tanstack/react-query"
import { pricingKeys } from "./queryKeys"
import { getMarketCurrentPtc, getMarketRates, getPtcHistory } from "./pricing"

export const useGetMarketCurrentPtcQuery = (
  market_code: string | undefined,
  revenue_class_code: string | undefined,
) => {
  return useQuery({
    queryKey: pricingKeys.marketCurrentPtc(market_code, revenue_class_code),
    queryFn:
      market_code && revenue_class_code
        ? () => getMarketCurrentPtc(market_code, revenue_class_code)
        : skipToken,
  })
}

export const useGetPtcHistoryQuery = (
  market_code: string | undefined,
  revenue_class_code: string | undefined,
) => {
  return useQuery({
    queryKey: pricingKeys.ptcHistory(market_code, revenue_class_code),
    queryFn:
      market_code && revenue_class_code
        ? () => getPtcHistory(market_code, revenue_class_code)
        : skipToken,
  })
}

export const useGetMarketRatesQuery = (
  market_code: string | undefined,
) => {
  return useQuery({
    queryKey: pricingKeys.marketRates(market_code),
    queryFn:
      market_code 
        ? () => getMarketRates(market_code)
        : skipToken,
  })
}
